var _rect, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46526_10717)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 18.5,
    width: 14,
    height: 6,
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16917 18.1273C7.27725 17.8463 7.33129 17.7058 7.40184 17.5743C7.46452 17.4576 7.53685 17.3462 7.61809 17.2416C7.70956 17.1237 7.816 17.0173 8.02888 16.8044L16.9587 7.87459C17.8331 7.00014 19.2509 7.00014 20.1253 7.87459C20.9998 8.74904 20.9998 10.1668 20.1253 11.0413L11.1955 19.971C10.9827 20.1839 10.8762 20.2904 10.7584 20.3818C10.6537 20.4631 10.5424 20.5354 10.4256 20.5981C10.2942 20.6686 10.1537 20.7227 9.87266 20.8307L5.47949 22.5204L7.16917 18.1273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10884 18.2842C7.22543 17.981 7.28373 17.8295 7.38372 17.76C7.4711 17.6994 7.57923 17.6764 7.68373 17.6964C7.8033 17.7192 7.91813 17.834 8.14779 18.0637L9.93624 19.8521C10.1659 20.0818 10.2807 20.1966 10.3036 20.3162C10.3235 20.4207 10.3006 20.5288 10.2399 20.6162C10.1705 20.7162 10.0189 20.7745 9.71576 20.8911L5.47949 22.5204L7.10884 18.2842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47949 22.5204L9.87266 20.8307C10.1537 20.7227 10.2942 20.6686 10.4256 20.5981C10.5424 20.5354 10.6537 20.4631 10.7584 20.3818C10.8762 20.2904 10.9827 20.1839 11.1955 19.971L20.1253 11.0413C20.9998 10.1668 20.9998 8.74904 20.1253 7.87459C19.2509 7.00014 17.8331 7.00014 16.9587 7.87459L8.02888 16.8044C7.816 17.0173 7.70956 17.1237 7.61809 17.2416C7.53685 17.3462 7.46452 17.4576 7.40184 17.5743C7.33129 17.7058 7.27725 17.8463 7.16917 18.1273L5.47949 22.5204ZM5.47949 22.5204L7.10884 18.2842C7.22543 17.981 7.28373 17.8295 7.38372 17.76C7.4711 17.6994 7.57923 17.6764 7.68373 17.6964C7.8033 17.7192 7.91813 17.834 8.14779 18.0637L9.93624 19.8521C10.1659 20.0818 10.2807 20.1966 10.3036 20.3162C10.3235 20.4207 10.3006 20.5288 10.2399 20.6162C10.1705 20.7162 10.0189 20.7745 9.71576 20.8911L5.47949 22.5204Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14.5L26.5 18.5L29.5 14.5",
    fill: "#475467"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46526_10717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(3.5 5.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.87ff6eb64fa2026008b7c630f4be0bd6.svg";
export { ForwardRef as ReactComponent };